<script>
  import { onMount, tick } from "svelte";
  import CenteredMenuDialog from "../../components/layout/menuDialog/variants/CenteredMenuDialog.svelte";
  import MenuDialogSectionEntry from "../../components/layout/menuDialog/MenuDialogSectionEntry.svelte";
  import MenuDialogSectionEntryTitle from "../../components/layout/menuDialog/MenuDialogSectionEntryTitle.svelte";
  import GeneralInput from "../../components/input/GeneralInput.svelte";
  import { translate } from "../../i18n/i18next.js";
  import DialogTitle from "../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../components/dialog/DialogContent.svelte";
  import DialogBottomControls from "../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../components/dialog/DialogBottomControlButton.svelte";
  import GeneralSelect from "../select/GeneralSelect.svelte";
  import {
    mostRecentChange,
    selectedDisplayPeriodS,
    selectedDisplayRowNumS,
    selectedUnitPeriodS,
  } from "./loadGraphStore.js";

  let dialog

  export let unitPeriod = [];
  export let displayPeriod = [];
  const minValue = 1;
  export let maxValue = 30;
  export let onClose;
  

  function handleChange(event) {
    const selectElement = event.target;
    const selectedValue = selectElement.value;
    const customOptionIndex = displayPeriod.findIndex(option => option.isCustom);
    if (customOptionIndex !== -1) {
        displayPeriod.splice(customOptionIndex, 1);
    }
    selectElement.style.color = '';
  }

  function handleInputChange(event) {
    const selectElement = event.target;
    const selectedValue = selectElement.value;
  }

  function handleInput(event) {
    const selectElement = event.target;
    const selectedValue = selectElement.value;

    if (selectedValue >= minValue && selectedValue <= maxValue) {
      selectElement.style.color = '';
      selectedDisplayRowNumS.set(selectedValue);
    } else {
      selectElement.style.color = 'red';
      /* selectElement.value = `${selectedValue} (Invalid Value)`; */
    }
  }
  
  function closeDialog() {
    dialog.close()
    onClose()
  }

  onMount(async () => {
    await tick()
    dialog.showModal()
  })
</script>

<CenteredMenuDialog
  bind:dialog={dialog}
  onClose={closeDialog}
>
  <DialogTitle title={translate("frontend:ganttChart.settings.sections.displaySettings.title")} />
  <DialogSplitter/>
  <DialogContent>
    <!-- Display span settings -->
    <MenuDialogSectionEntry>
      <MenuDialogSectionEntryTitle>単位期間</MenuDialogSectionEntryTitle>
      <GeneralSelect options={unitPeriod} bind:value={$selectedUnitPeriodS} extraStyle="width: 100%;"/>
    </MenuDialogSectionEntry>
    <MenuDialogSectionEntry>
      <MenuDialogSectionEntryTitle>
        表示期間
      </MenuDialogSectionEntryTitle>
      <GeneralSelect options={displayPeriod} bind:value={$selectedDisplayPeriodS} onChangeEvent={handleChange} selectId="displayPeriodSelect" extraStyle="width: 100%;"/>
    </MenuDialogSectionEntry>
    <MenuDialogSectionEntry>
      <MenuDialogSectionEntryTitle>表示数</MenuDialogSectionEntryTitle>
      <GeneralInput value={$selectedDisplayRowNumS} min={minValue} max={maxValue} onChange={handleInputChange} onInput={handleInput} extraStyle="width: 100%;" type="number"/>
    </MenuDialogSectionEntry>
  </DialogContent>
  <DialogSplitter/>
  <DialogBottomControls>
    <DialogBottomControlButton type="primary" onClick={onClose}>OK</DialogBottomControlButton>
  </DialogBottomControls>
</CenteredMenuDialog>

<style>

</style>
